import { APIProvider, Map, useMap } from "@vis.gl/react-google-maps";
import {
  ForwardedRef,
  forwardRef,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import i18n from "@/i18n/i18n";
import { t } from "i18next";
import { BEETLE_MAP_ID, findVenueCenter, getSupportedVenueData } from "@/types/supported-venue";
import Text from "@/components/text/text";

import { BeetleMarker } from "../components/beetle-marker";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export type Map2DProps = {
  center: google.maps.LatLngAltitudeLiteral;
  onZoomIn?: () => void;
  showToast?: (venueName: string) => void;
  hideToast?: () => void;
  selectedVenue?: string
  isFlutter: boolean;
}

export type Map2DBounds = {
  northeast: google.maps.LatLng;
  southwest: google.maps.LatLng;
  zoomLevel: string;
}


const GoogleMapSatellite = forwardRef(
  (
    props: Map2DProps,
    ref: ForwardedRef<google.maps.maps3d.Map3DElement>
    // forwardedRef: ForwardedRef<google.maps.maps3d.Map3DElement | null>
  ) => {
    const map = useMap();
    const { center } = props;
    const [camera, setCamera] = useState({
      center: { lat: 22.30237838835916, lng: 114.1671534828049, altitude: 1300 },
      range: 2000,
      heading: 0,
      tilt: 0,
      roll: 0,
    });

    const [bounds, setBounds] = useState<Map2DBounds | null>(null);

    // const clustererRef = useRef<MarkerClusterer | null>(null);
    // const markersRef = useRef<{ [key: string]: google.maps.marker.AdvancedMarkerElement }>({});

    // useEffect(() => {
    //   if (!map) return;

    //   if (!clustererRef.current) {
    //     const renderer = {
    //       render({ count, position }: { count: any, position: any }) {
    //         return new google.maps.Marker({
    //           // label: { text: String(count), color: "white", fontSize: "10px" },
    //           position,
    //           icon: {
    //             url: "/assets/icon_comm_marker.svg",
    //             scaledSize: new google.maps.Size(24, 24),
    //           },
    //           // Adjust zIndex to be above other markers
    //           zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    //         });
    //       },
    //     };
    //     clustererRef.current = new MarkerClusterer({
    //       map: map as any, renderer, onClusterClick: (event, cluster, map) => {
    //         const clusterMarkers = cluster.markers;
    //         console.log("Markers in this cluster:", clusterMarkers);

    //         clusterMarkers.forEach(marker => {
    //           const advancedMarker = marker as google.maps.marker.AdvancedMarkerElement;
    //           console.log("Marker Title:", advancedMarker.title);
    //         });
    //       }
    //     });
    //     console.log("set clustererRef")
    //   }

    //   return () => {
    //     // Cleanup on unmount
    //     if (clustererRef.current) {
    //       clustererRef.current.clearMarkers();
    //       console.log("clearMarkers")
    //     }
    //   };
    // }, [map]);

    useEffect(() => {
      setCamera({
        center: { lat: center.lat, lng: center.lng, altitude: 1300 },
        range: 2000,
        heading: 0,
        tilt: 0,
        roll: 0,
      });
    }, [center]);

    const handleCameraChange = useCallback((e: any) => {

      setCamera(e.detail)
      if (map) {
        const latLngBounds = map.getBounds();
        const zoom = map.getZoom();
        if (latLngBounds && zoom) {
          setBounds({
            northeast: latLngBounds.getNorthEast(),  // {lat, lng}
            southwest: latLngBounds.getSouthWest(),
            zoomLevel: zoom.toString()
          });
        }
      }
    }, [map]);

    // useEffect(() => {
    //   const clusterer = clustererRef.current;
    //   if (!clusterer) return;
    //   clusterer.clearMarkers();
    //   clusterer.addMarkers(Object.values(markersRef.current));
    // }, [Object.keys(markersRef.current).length]);

    // const handleMarkerRef = (marker: google.maps.marker.AdvancedMarkerElement | null, id: string) => {
    //   if (marker && !markersRef.current[id]) {
    //     markersRef.current[id] = marker;
    //   } else if (!marker && markersRef.current[id]) {
    //     delete markersRef.current[id];
    //   }
    // };

    console.log("camera center", center)
    return (

      <Map
        {...camera}
        tilt={0}
        heading={0}
        minZoom={5}
        defaultZoom={15}
        defaultCenter={center}
        disableDefaultUI={true}
        mapId={BEETLE_MAP_ID}
        onCameraChanged={handleCameraChange}
        clickableIcons={false} // disable clickable POIs
        keyboardShortcuts={false}
      >
        {bounds && <BeetleMarker bounds={bounds} map={map} />}
      </Map>
    );
  }
);

const GoogleMap2D = ({
  onZoomIn,
  isConstrained = false,
  venueCode = "",
  isFlutter = false,
}: {
  onZoomIn?: () => void;
  isConstrained?: boolean;
  venueCode?: string;
  isFlutter?: boolean;
}) => {
  const API_KEY = process.env.REACT_APP_MAP_KEY || "";

  const [cameraState, setCameraState] = useState({
    center: { lat: 22.30237838835916, lng: 114.1671534828049, altitude: 1300 },
    range: 2000,
    heading: 0,
    tilt: 0,
    roll: 0,
  });


  useEffect(() => {

    const handleInitLocationUpdate = (event: any) => {
      const { lat, lng } = event.detail;
      setCameraState({
        center: { lat: lat, lng: lng, altitude: 1300 },
        range: 2000,
        heading: 0,
        tilt: 0,
        roll: 0,
      });
      console.log("handleInitLocationUpdate", lat, lng);
    };

    window.addEventListener("flutterInitLocationUpdate", handleInitLocationUpdate);
    return () => {
      window.removeEventListener("flutterInitLocationUpdate", handleInitLocationUpdate);
    }
  }, []);

  const getInitialViewProps = () => {
    const initProps = {
      center: { lat: 22.30237838835916, lng: 114.1671534828049, altitude: 1300 },
      range: 2000,
      heading: 0,
      tilt: 0,
      roll: 0,
    };

    if (venueCode === "map") {
      return initProps
    }

    const center = findVenueCenter(venueCode);
    if (center) {
      return {
        center: { lat: center["lat"], lng: center["lng"], altitude: 100 },
        range: 50,
        heading: 0,
        tilt: 0,
        roll: 0,
      };
    }

    return initProps
  };

  const [showToast, setShowToast] = useState(false);
  const [venueName, setVenueName] = useState("");

  return (
    <div className={`w-full  ${isConstrained ? "h-full" : "h-screen"} `}>
      <APIProvider apiKey={API_KEY}>
        <GoogleMapSatellite
          {...cameraState}
          onZoomIn={onZoomIn}
          showToast={(venueName) => {
            setShowToast(true);
            setVenueName(venueName);
          }}
          hideToast={() => setShowToast(false)}
          selectedVenue={venueCode}
          isFlutter={isFlutter}
        />
      </APIProvider>

      {showToast && (
        <div className="fixed z-[30] bg-overlay-map p-10 text-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 animate-fade-in rounded-md">
          <Text
            className="primary-text font-semibold mb-5"
            text={venueName}
            size={18}
          />
          <Text
            className="primary-text font-semibold"
            text="coming_soon"
            size={14}
          />
        </div>
      )}
    </div>
  );
};
export default GoogleMap2D;
